import { useSelector } from "react-redux";
import DecreaseDailyIncome from "./DecreaseDailyIncome";
import IncomeGaps from "./IncomeGaps";
import AnomaliesSkeleton2 from "../../AnomaliesSkeleton2";

const AnomaliesIncome = () => {
  const isFetchedForIncomeData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForIncomeData,
  );

  return (
    <>
      {isFetchedForIncomeData ? (
        <>
          <IncomeGaps />
          <DecreaseDailyIncome />
        </>
      ) : (
        <AnomaliesSkeleton2 />
      )}
    </>
  );
};

export default AnomaliesIncome;
